export const enum AgentTabListEvent {
  clickEmail = 'click-email',
}
